export const FILTER_COLLECTION_NAME = 'lifecycleAnalyticsFilters';
export const DISPLAY_DATE_FORMAT = 'MM-DD-YYYY';
export const MAX_SUPPLIERS_IN_TABLE = 35;
export const VIEW_MODE = {
	ALL: 'all',
	SINGLE: 'single',
	EXPANDED: 'expanded',
};

export const CHART_METRIC = {
	APPROVAL_TIME: 'approval_time',
	RESPONSE_TIME: 'response_time',
	RESOLUTION_TIME: 'resolution_time',
	FIRST_TIME_FIX_RATE: 'first_time_fix_rate',
};

export const MONTH_ABBR = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec',
];

export const MONTH_FULL = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];

export const PERFORMER_GROUP = {
	TOP: 'Top Performers',
	TYPICAL: 'Typical Performers',
	BOTTOM: 'Bottom Performers',
};

export const PERFORMER_SHAPE = {
	STAR: 'topPerformerStar',
	CROSS: 'cross',
	CIRCLE: 'hollowCircle',
};

export const PERFORMER_GROUP_ORDER = [
	PERFORMER_GROUP.TOP,
	PERFORMER_GROUP.TYPICAL,
	PERFORMER_GROUP.BOTTOM,
];

export const AXIS_Y_LINE_COLOR = '#D9D9D9';
export const AXIS_X_LINE_COLOR = '#E8E8E8';

export const POSITIVE_CHANGE_COLOR = '#f5222d';
export const NEGATIVE_CHANGE_COLOR = '#389E0D';
export const CHART_PRIMARY_COLOR = '#722ED1';

export const CHART_METRIC_OPTIONS = [
	{
		key: CHART_METRIC.APPROVAL_TIME,
		label: 'Avg Approval Time',
		dataField: 'avgApprovalTimeSeconds',
		changeField: 'avgApprovalTimeSeconds',
		axisTitle: 'Avg. Approval Time',
		isTimeBased: true,
		infoTooltip: 'Calculated on WOs that require manual approval',
	},
	{
		key: CHART_METRIC.RESPONSE_TIME,
		label: 'Avg Response Time',
		dataField: 'avgResponseTimeSeconds',
		changeField: 'avgResponseTimeSeconds',
		axisTitle: 'Avg. Response Time',
		isTimeBased: true,
	},
	{
		key: CHART_METRIC.RESOLUTION_TIME,
		label: 'Avg Resolution Time',
		dataField: 'avgResolutionTimeSeconds',
		changeField: 'avgResolutionTimeSeconds',
		axisTitle: 'Avg. Resolution Time',
		isTimeBased: true,
	},
	{
		key: CHART_METRIC.FIRST_TIME_FIX_RATE,
		label: 'First Time Fix Rate',
		dataField: 'firstTimeFixRate',
		changeField: 'firstTimeFixRate',
		axisTitle: 'First Time Fix Rate (%)',
		isTimeBased: false,
	},
];
